import styles from "./BenefitRow.module.scss";

interface BenefitRowProps {
	badge: string;
	title: string;
	description: string;
	leftIcon?: React.ReactNode;
}

export const BenefitRow: React.FC<BenefitRowProps> = ({ badge, title, description, leftIcon }) => (
	<div className={styles.benefitRow}>
		{leftIcon ?? <div className={styles.badge}>{badge}</div>}

		<div className={styles.benefitContent}>
			<span className={styles.benefitTitle}>{title}</span>
			<span className={styles.benefitDescription}>{description}</span>
		</div>
	</div>
);
